@if (loading) {
  <app-admin-state-panel
    mode="loading"
    titleKey="COMMON.LOADING"
    descriptionKey="ADMIN.USERS.DETAIL.LOADING"
  ></app-admin-state-panel>
} @else if (hasError || !user) {
  <app-admin-state-panel
    mode="error"
    titleKey="COMMON.ERROR"
    descriptionKey="ADMIN.USERS.DETAIL.ERROR"
    [showRetry]="true"
    (retry)="load()"
  ></app-admin-state-panel>
} @else {
  <app-admin-form-layout
    titleKey="ADMIN.USERS.DETAIL.SECURITY.LANDING_TITLE"
    descriptionKey="ADMIN.USERS.DETAIL.SECURITY.LANDING_DESCRIPTION"
  >
    <app-form-user-login-page [user]="user" [onUpdate]="reload"></app-form-user-login-page>
  </app-admin-form-layout>
}
